import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function EmailQuoteDialog({ open, onOpenChange, cartId, cartName }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post(`/carts/${cartId}/email-quote`, {
        recipient_email: email,
        base_url: window.location.origin,
      });
      toast.success(`Quote sent to ${email}`);
      onOpenChange(false);
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to send");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="email-quote-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-bold text-xl tracking-tight text-gray-900">Email Quote</DialogTitle>
          <DialogDescription className="text-gray-500">
            Send the customer a product quotation from cart "{cartName}", including a self-serve online link to recalculate quantities (valid for 7 days).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSend} className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-gray-600">Recipient Email</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="customer@example.com"
              data-testid="email-quote-recipient-input"
              className="mt-1.5 rounded-lg border-gray-300 focus-visible:ring-brand-500"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-lg border-gray-300">Cancel</Button>
            <Button type="submit" disabled={sending} data-testid="email-quote-send-button" className="rounded-lg bg-[#1677ff] hover:bg-[#0958d9]">
              <Mail size={14} className="mr-1.5" /> {sending ? "Sending..." : "Send"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
